export enum SetStatusResponseType {
  Redirect = 1,
  Routed = 2,
  AfterComplete = 3,
  Success = 4,
  AfterCompleteReconfirmContact = 5,
  AfterCompleteConsent = 6
}
